import Login from './components/Login.vue';
import ManageUsers from './views/ManageUsers.vue';
import ManageRole from './views/ManageRoles.vue';
import UserRoles from './views/UserRoles.vue';
import UserProfile from './views/UserProfile.vue';
import Report from './views/Report.vue';
import EditUsers from './views/EditUsers.vue';
//Announcement imports
import AnnouncementsView from './views/AnnouncementsView.vue';
import CreateAnnouncementView from './views/CreateAnnouncementView.vue';
import UpdateAnnouncementView from './views/UpdateAnnouncementView.vue';
import CreateUser from './components/CreateUser.vue';
import EditUserRole from './components/EditUserRole.vue';
import ForgotPasswordReset from './components/ForgotPasswordReset.vue';
import Folder from './components/Folder.vue';
import Home from './views/Home.vue';
import MyInfo from './views/MyInfo.vue';
import EditMyInfo from './views/EditMyInfo.vue';
import People from './views/People.vue';
// import Files from './views/Files.vue';
import Help from './views/Help.vue';
import FileUpload from './views/FileUpload.vue';
import passwordChange from './views/passwordChange.vue';
import LinkExpired from './views/LinkExpired.vue';
import { routeNames } from './js/routeNames';
import { decryptData } from './js/utils/encrypt';
import { createRouter, createWebHashHistory } from 'vue-router';
// import AdminDashboard from './components/Dashboard/AdminDashboard.vue';
import DirectReport from './views/DirectReport';
import EditEmployees from './views/EditEmployees.vue';
import {
  getCookie,
  removeAllLocalStorage,
  getLocalStorageByName,
} from './js/composables';
import EmployeeReport from './components/Reports.vue';
// import AssignedLeave from './components/AssignedLeave.vue';
import Team from './components/Team.vue';
import LeaveAdjustment from './components/LeaveAdjustment.vue';

import twofa from './components/Twofa.vue';
import PerformanceManagement from './views/PerformanceManagement';
import ViewPerformanceManagement from './views/ViewPerformanceManagement';
import EditPerformanceManagement from './views/EditPerformanceManagement';
//Decrypting Permissions
// let mkLocalData = localStorage.getItem('Permissions');
// if (!mkLocalData) {
//     mkLocalData = 'null';
// }

const secretPermissionKey = process.env.KEY || 'myscecretkey';
// var permissions = decryptData(getLocalStorageByName('Permissions'), secretPermissionKey);

const routes = [
  {
    path: '/performancemanagement/:id?/:name?/:departments?/:formId?',
    name: routeNames.performanceManagement,
    component: PerformanceManagement,
    beforeEnter: (to, from, next) => {
      if(getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else {
        next();
      }
    },
  },

  {
    path: '/viewperformancemanagement',
    name: routeNames.viewPerformanceManagement,
    component: ViewPerformanceManagement,
    beforeEnter: (to, from, next) => {
      if(getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else {
        next();
      }
    }
  },

  {
    path: '/editperformancemanagement/:id?/:name?/:departments?/:formId?/:formType?',
    name: routeNames.editPerformanceManagement,
    component: EditPerformanceManagement,
    beforeEnter: (to, from, next) => {
      if(getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else {
        next();
      }
    }
  },

  {
    path: '/userprofile',
    name: routeNames.userProfile,
    component: UserProfile,
    beforeEnter: (to, from, next) => {
      if (getCookie('2faToken') != '') next();
      else {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      }
    },
  },
  {
    path: '/report',
    name: routeNames.report,
    component: Report,
    beforeEnter: (to, from, next) => {
      var permissions = decryptData(
        getLocalStorageByName('Permissions'),
        secretPermissionKey
      );
      if (getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else if (!permissions.includes('View-Report')) next({ path: '/home' });
      else {
        next();
      }
    },
  },

  //Announcements
  {
    path: '/announcements',
    name: routeNames.announcements,
    component: AnnouncementsView,
    beforeEnter: (to, from, next) => {
      var permissions = decryptData(
        getLocalStorageByName('Permissions'),
        secretPermissionKey
      );
      if (getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else if (!permissions.includes('Announcement-Permission')) next({ path: '/home' });
      else {
        next();
      }
    },
  },
  {
    path: '/createannouncement',
    name: routeNames.createAnnouncement,
    component: CreateAnnouncementView,
    beforeEnter: (to, from, next) => {
      var permissions = decryptData(
        getLocalStorageByName('Permissions'),
        secretPermissionKey
      );
      if (getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else if (!permissions.includes('Announcement-Permission')) next({ path: '/home' });
      else {
        next();
      }
    },
  },
  {
    path: '/updateannouncement/:id',
    name: routeNames.updateAnnouncement,
    component: UpdateAnnouncementView,
    beforeEnter: (to, from, next) => {
      var permissions = decryptData(
        getLocalStorageByName('Permissions'),
        secretPermissionKey
      );
      if (getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else if (!permissions.includes('Announcement-Permission')) next({ path: '/home' });
      else {
        next();
      }
    },
  },
  //Announcements

  {
    path: '/leaves',
    name: routeNames.leaves,
    component: LeaveAdjustment,
    beforeEnter: (to, from, next) => {
      var permissions = decryptData(
        getLocalStorageByName('Permissions'),
        secretPermissionKey
      );
      if (getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else if (!permissions.includes('Leave-Admin')) next({ path: '/home' });
      else {
        next();
      }
    },
  },
  {
    path: '/',
    name: routeNames.login,
    component: Login,
    beforeEnter: (to, from, next) => {
      if (getCookie('token') != '')
        if (getCookie('2faToken') != '') next({ path: '/home' });
        else {
          next();
        }
      else {
        removeAllLocalStorage();
        next();
      }
    },
  },
  {
    path: '/help',
    name: routeNames.help,
    component: Help,
    beforeEnter: (to, from, next) => {
      if (getCookie('2faToken') != '') next();
      else {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      }
    },
  },
  {
    path: '/team',
    name: routeNames.team,
    component: Team,
    beforeEnter: (to, from, next) => {
      if (getCookie('2faToken') != '') next();
      else {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      }
    },
  },
  {
    path: '/linkexpired',
    name: routeNames.linkexpired,
    component: LinkExpired,
    beforeEnter: (to, from, next) => {
      if (getCookie('2faToken') != '' || getCookie('token') != '')
        next({ path: '/' });
      else {
        removeAllLocalStorage();
        next();
      }
    },
  },
  {
    path: '/folder',
    name: routeNames.folder,
    component: Folder,
    beforeEnter: (to, from, next) => {
      // var permissions = decryptData(getLocalStorageByName('Permissions'), secretPermissionKey);
      if (getCookie('token') == '') {
        removeAllLocalStorage();
        next({ path: '/' });
      } else if (getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      }
      // else if (!permissions.includes('File-Access-Permission'))
      //     next({ path: '/home' });
      else {
        next();
      }
    },
  },
  {
    path: '/fileupload',
    name: routeNames.fileupload,
    component: FileUpload,
    beforeEnter: (to, from, next) => {
      var permissions = decryptData(
        getLocalStorageByName('Permissions'),
        secretPermissionKey
      );
      if (getCookie('token') == '') {
        removeAllLocalStorage();
        next({ path: '/' });
      } else if (getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else if (!permissions.includes('File-Access-Permission'))
        next({ path: '/home' });
      else {
        next();
      }
    },
  },
  {
    path: '/people',
    name: routeNames.People,
    component: People,
    beforeEnter: (to, from, next) => {
      if (getCookie('2faToken') != '') next();
      else {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      }
    },
  },
  // {
  //   path: '/files',
  //   name: routeNames.Files,
  //   component: Files,
  //   beforeEnter: (to, from, next) => {
  //     var permissions = decryptData(
  //       getLocalStorageByName('Permissions'),
  //       secretPermissionKey
  //     );
  //     if (getCookie('2faToken') == '') {
  //       removeAllLocalStorage();
  //       next({ path: '/twofa' });
  //     } else if (!permissions.includes('Viewer')) next({ path: '/home' });
  //     else {
  //       next();
  //     }
  //   },
  // },
  {
    path: '/myinfo',
    name: routeNames.myInfo,
    component: MyInfo,
    beforeEnter: (to, from, next) => {
      if (getCookie('2faToken') != '') next();
      else {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      }
    },
  },

  {
    path: '/twofa',
    name: routeNames.twofa,
    component: twofa,
    beforeEnter: (to, from, next) => {
      if (getCookie('token') != '') {
        next();
      } else {
        removeAllLocalStorage();
        next();
      }
    },
  },

  {
    path: '/home',
    name: routeNames.home,
    component: Home,
    beforeEnter: (to, from, next) => {
      if (getCookie('2faToken') != '') next();
      else {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      }
    },
  },
  {
    path: '/passwordChange',
    name: routeNames.passwordChange,
    component: passwordChange,
    beforeEnter: (to, from, next) => {
      if (getCookie('pwdResetToken') == '') next({ path: '/' });
      else {
        next();
      }
    },
  },
  {
    path: '/reset-password/:token/:email',
    name: routeNames.resetPassword,
    component: ForgotPasswordReset,
    meta: {
      auth: false,
    },
  },
  {
    path: '/help',
    name: routeNames.help,
    component: Help,
    beforeEnter: (to, from, next) => {
      if (getCookie('2faToken') != '') next();
      else {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      }
    },
  },
  {
    path: '/team',
    name: routeNames.team,
    component: Team,
    beforeEnter: (to, from, next) => {
      if (getCookie('2faToken') != '') next();
      else {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      }
    },
  },
  {
    path: '/linkexpired',
    name: routeNames.linkexpired,
    component: LinkExpired,
    beforeEnter: (to, from, next) => {
      if (getCookie('2faToken') != '' || getCookie('token') != '')
        next({ path: '/' });
      else {
        removeAllLocalStorage();
        next();
      }
    },
  },
  {
    path: '/folder',
    name: routeNames.folder,
    component: Folder,
    beforeEnter: (to, from, next) => {
      // var permissions = decryptData(
      //   getLocalStorageByName('Permissions'),
      //   secretPermissionKey
      // );
      if (getCookie('token') == '') {
        removeAllLocalStorage();
        next({ path: '/' });
      } else if (getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } 
      // else if (!permissions.includes('File-Access-Permission'))
      //   next({ path: '/home' });
      else {
        next();
      }
    },
  },
  {
    path: '/people',
    name: routeNames.People,
    component: People,
    beforeEnter: (to, from, next) => {
      if (getCookie('2faToken') != '') next();
      else {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      }
    },
  },
  {
    path: '/myinfo',
    name: routeNames.myInfo,
    component: MyInfo,
    beforeEnter: (to, from, next) => {
      if (getCookie('2faToken') != '') next();
      else {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      }
    },
  },
  {
    path: '/myinfo/edit/:empid?',
    name: routeNames.editMyInfo,
    component: EditMyInfo,
    beforeEnter: (to, from, next) => {
      if (getCookie('2faToken') != '') next();
      else {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      }
    },
  },
  {
    path: '/directreport/:id?',
    name: routeNames.directreport,
    component: DirectReport,
    props: true,
    beforeEnter: (to, from, next) => {
      if (getCookie('2faToken') != '') next();
      else {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      }
    },
  },
  {
    path: '/manageuser',
    name: routeNames.manageUser,
    component: ManageUsers,
    beforeEnter: (to, from, next) => {
      var permissions = decryptData(
        getLocalStorageByName('Permissions'),
        secretPermissionKey
      );
      if (getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else if (!permissions.includes('View-User')) next({ path: '/home' });
      else {
        next();
      }
    },
  },
  {
    path: '/manageroles',
    name: routeNames.manageRole,
    component: ManageRole,
    beforeEnter: (to, from, next) => {
      var permissions = decryptData(
        getLocalStorageByName('Permissions'),
        secretPermissionKey
      );
      if (getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else if (!permissions.includes('View-Role')) next({ path: '/home' });
      else {
        next();
      }
    },
  },
  {
    path: '/edituser/:userid',
    name: routeNames.editUser,
    component: EditUsers,
    beforeEnter: (to, from, next) => {
      var permissions = decryptData(
        getLocalStorageByName('Permissions'),
        secretPermissionKey
      );
      if (getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else if (!permissions.includes('Edit-User'))
        next({ path: '/manageuser' });
      else {
        next();
      }
    },
  },
  {
    path: '/editemployee/:empid?',
    name: routeNames.editEmployee,
    component: EditEmployees,
    beforeEnter: (to, from, next) => {
      var permissions = decryptData(
        getLocalStorageByName('Permissions'),
        secretPermissionKey
      );
      if (getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else if (!permissions.includes('Edit-User')) next({ path: '/people' });
      else {
        next();
      }
    },
  },

  {
    path: '/newroles',
    name: routeNames.newUserRole,
    component: UserRoles,
    beforeEnter: (to, from, next) => {
      var permissions = decryptData(
        getLocalStorageByName('Permissions'),
        secretPermissionKey
      );
      if (getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else if (!permissions.includes('Create-Role'))
        next({ path: '/manageroles' });
      else {
        next();
      }
    },
  },
  {
    path: '/editroles/:roleid/:rolename',
    name: routeNames.editUserRole,
    component: EditUserRole,
    beforeEnter: (to, from, next) => {
      var permissions = decryptData(
        getLocalStorageByName('Permissions'),
        secretPermissionKey
      );
      if (getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else if (!permissions.includes('Edit-Role'))
        next({ path: '/manageroles' });
      else {
        next();
      }
    },
  },
  {
    path: '/newuser',
    name: routeNames.newUser,
    component: CreateUser,
    beforeEnter: (to, from, next) => {
      var permissions = decryptData(
        getLocalStorageByName('Permissions'),
        secretPermissionKey
      );
      if (getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else if (!permissions.includes('Create-User'))
        next({ path: '/manageuser' });
      else {
        next();
      }
    },
  },
  {
    path: '/employee-report',
    name: routeNames.employeeReport,
    component: EmployeeReport,
    beforeEnter: (to, from, next) => {
      var permissions = decryptData(
        getLocalStorageByName('Permissions'),
        secretPermissionKey
      );
      if (getCookie('2faToken') == '') {
        removeAllLocalStorage();
        next({ path: '/twofa' });
      } else if (!permissions.includes('View-Report'))
        next({ path: '/home' });
      else {
        next();
      }
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    to.name !== routeNames.login &&
    getCookie('token') == '' &&
    getCookie('pwdResetToken') == '' &&
    to.name !== routeNames.resetPassword &&
    to.name !== routeNames.linkexpired
  ) {
    next({ name: routeNames.login });
  } else next();
});

export default router;
